import { render } from "./definitions.vue?vue&type=template&id=cf9d5976"
import script from "./definitions.vue?vue&type=script&lang=js"
export * from "./definitions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__